import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { 
    DOCUMENT_CONTENT_TYPE_PDF, 
    DOCUMENT_TYPE_FORMS_AGREEMENTS, 
    DOCUMENT_TYPE_NOTICES_LETTERS, 
    DOCUMENT_TYPE_SURETY_BONDS 
} from "../../../../../app/constants";
import { convertFileDataForUrl } from "../../../../../app/documentUploadUtils";
import { humanReadableDate } from "../../../../../app/utils";
import { DocumentViewerFileNameLink, DownloadFileNameLink } from "../../../../../components/DocumentViewer/DocumentFileComponent";
import DocumentViewer from "../../../../../components/DocumentViewer/DocumentViewer";
import { BackButton, Button, LineSeperator } from "../../../../../components/RegularComponents";
import { saveBusinessLicenceApplicationData } from "../../../../../redux/slice/businessLicenceApplicationSlice";
import { setAgencySupportingDocuments } from "../../../../../redux/slice/primaryAgencyApplicationSlice";
import { fetchDocumentData } from "../../../../../redux/slice/supportingDocumentsSlice"

export const AttachmentDetails = (props) => {

    const {
        licenceApplication, 
        attachment, 
        setAttachment, 
        applicationMode, 
        applicationType, 
        isArchiveApplication
    } = props;

    const [documents, setDocuments] = useState({formsAgreements: [], noticesLetters: [] });
    const dispatch = useDispatch();
    
    const [openDocumentViewer, setOpenDocumentViewer] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null)

    useEffect(() => {
        const formsAgreements = []
        const noticesLetters = []
        const suretyBondDocs = []
        licenceApplication.documents.forEach((document) => {
            if(document.documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS) {
                formsAgreements.push(document)
            } else if(document.documentType === DOCUMENT_TYPE_NOTICES_LETTERS) {
                noticesLetters.push(document)
            } else if(document.documentType === DOCUMENT_TYPE_SURETY_BONDS) {
                suretyBondDocs.push(document)
            }
        })
        setDocuments({formsAgreements, noticesLetters, suretyBondDocs})
    }, [licenceApplication])

    const handleGoBack = () => {
        setAttachment()
    }

    const detailRows = useMemo(() => {
        
        const documentComponent = (d) => { 
            return (
                <>
                    { d.documentContentType === DOCUMENT_CONTENT_TYPE_PDF ? 
                        <DocumentViewerFileNameLink
                            id={"bladmin-information-attachment-file-" + d.filename}
                            key={"bladmin-information-attachment-file-" + d.filename}
                            file={d} 
                            onClick={() => {
                                if(d.data) { 
                                    let fileDataUrl = convertFileDataForUrl(d.data, d.documentContentType)
                                    setDocumentViewerDocument(fileDataUrl)
                                    setOpenDocumentViewer(true)
                                    setSelectedFile(d)
                                } else { 
                                    // download data and then view it.
                                    if(d.guid) { 
                                        dispatch(fetchDocumentData(d.guid))
                                            .then(downloadFile => {
                                                if(downloadFile) {
                                                    let fileDataUrl = convertFileDataForUrl(downloadFile.data, downloadFile.documentContentType)
                                                    setDocumentViewerDocument(fileDataUrl)
                                                    setOpenDocumentViewer(true)
                                                    setSelectedFile(downloadFile)
                                                }
                                            })
                                            .catch((error) => {
                                                console.error(error)
                                            })
                                    }
                                }
                            }}
                        /> : 
                        <DownloadFileNameLink
                            id={"bladmin-information-attachment-download-file-" + d.filename}
                            componentKey={"bladmin-information-attachment-download-file-" + d.filename}
                            file={d} 
                        />}
                </>
            )
        }

        return [
            {
                title: "Attachment name",
                value: (<span style={{cursor: "pointer"}}>{documentComponent(attachment)}</span>)
            },
            {
                title: "Date received",
                value: humanReadableDate(attachment.createdDate)
            },
            {
                title: "Uploaded by",
                value: (<span>{attachment.createdBy}</span>)
            },
            {
                title: "Internal notes",
                value: (<span>{attachment.internalNotes}</span>)
            },
        ]
    }, [attachment, 
        setDocumentViewerDocument,
        setOpenDocumentViewer,
        setSelectedFile,
        dispatch
    ])

    const handleDelete = () => {
        // save and push to next
        const formsAgreements = [...documents.formsAgreements]
        const noticesLetters = [...documents.noticesLetters]

        const arr = attachment.documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS ? formsAgreements : noticesLetters
        const docIndex = arr.findIndex((att) => att.guid === attachment.guid)
        arr.splice(docIndex, 1, {...attachment, changeType: "DELETE"})

        dispatch(setAgencySupportingDocuments([
            ...(attachment.documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS ? arr : formsAgreements),
            ...(attachment.documentType === DOCUMENT_TYPE_NOTICES_LETTERS ? arr : noticesLetters),
            ...documents.suretyBondDocs
        ]))


        dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
            .then((data) => {
                window.location.reload();
            })
            .catch(err => {
                // setApplicationSaveError(true)
            })
    }
    
    return (
        <div className="licence-application-details-panel">
            <BackButton onClick={handleGoBack} />
            <div className="licence-application-details-panel">
                {detailRows.map((detailRow, i) => (
                    <div key={`attachment-details-${i}`}>
                        <DetailSection data={detailRow} />
                        <LineSeperator />
                    </div>
                ))}
            </div>
            <div className="row">
                <div className="collector-licence-col col-md-4"></div>
                <div className="collector-licence-col col-md-8">
                    <Button 
                        className="btn btn-danger" 
                        onClick={handleDelete} 
                        text="Permanently delete" 
                        disabled={isArchiveApplication}
                    />
                </div>
            </div>
            <DocumentViewer 
                fileData={documentViewerDocument}
                isOpen={openDocumentViewer}
                fileName={selectedFile?.filename}
                handleClose={() => setOpenDocumentViewer(false)}
            />
        </div>
    )
}


const DetailSection = ({ data }) => {
    return (
        <>
        <div className="row section-row-margin">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>{data.title}</span>
            </div>

            <div className="collector-licence-col col-md-8" style={{ display: "flex" }}>
                {data.value}
            </div>
        </div>
        </>
    )
}